import { getCurrentUserId } from 'gcs-common/slices/currentUser/currentUserSelectors';
import PropTypes from 'prop-types';
import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';

const MuxPlayer = React.lazy(() => import('@mux/mux-player-react'));

const VideoStreamPlayer = ({ videoId }) => {
  const currentUserId = useSelector(getCurrentUserId);

  return (
    <Suspense fallback="...">
      <MuxPlayer
        streamType="on-demand"
        playbackId={videoId}
        metadata={{
          viewer_user_id: { currentUserId },
        }}
        style={{ width: '100%', height: '100%' }}
        autoPlay
      />
    </Suspense>
  );
};

export default VideoStreamPlayer;
VideoStreamPlayer.propTypes = {
  videoId: PropTypes.string.isRequired,
};
